import React, {createContext, useState} from "react";
import {settingPage, settingPageRule} from "../CaseDesign/AddNewDocument.utils.props";

const board: any = {
    stages: []
};

type RuleComponent = {
        id: number;
        selectedRuleId: string; 
        dataRule: any;
    };

export const CaseDesignContext = createContext<CaseDesignContextValue>({
    caseDesignUpdate: {}, 
    setCaseDesignUpdate: () => { },
    resetState: settingPage.BASICINFO,
    setResetState: () => { },
    Name: {},
    setName: () => { },
    Type: {},
    setType: () => { },
    typeCaseVisible: {},
    setTypeCaseVisible: () => { },
    templates: {},
    setTemplates: () => { },
    eFormSubDocId: {},
    setEFormSubDocId: ()=> { },
    department: {},
    setDepartment: () => { },
    descriptions: {},
    setDescriptions: () => { },
    masterPage: {},
    setMasterPage: () => { },
    stages: {},
    setStages: () => { },
    steps: {},
    setSteps: () => { },
    stepsName: {},
    setStepsName: () => { },
    stagesName: {},
    setStagesName: () => { },
    duration: {},
    setDuration: () => { },
    timeInput: {},
    setTimeInput: () => { },
    timeHrs: {},
    setTimeHrs: () => { },
    timeMin: {},
    setTimeMin: () => { },
    timeDay: {},
    setTimeDay: () => { },
    initialBoard: board,
    setBoard: () => { },
    ruleData:[], 
    setRuleData: () => { },
    selectedRuleId: [], 
    setSelectedRuleId: () => { },
    ruleParameters: [],
    setRuleParameters: () => { },
    paramData:[], 
    setParamData:() => { },
    gotoData:[],
    setGotoData:() => { },
    valueGotoIfData:[],
    setValueGotoIfData:() => { },
    valueGotoElseData:{},
    setValueGotoElseData:() => { },
    pageRule:settingPageRule.FIRSTPAGE,
    setPageRule: () => { },
    selectedCard: {}, 
    setSelectedCard: () => { },
    selectedCardReference:{},
    setSelectedCardReference: () => { },
    caseOptionAssign: null,
    setCaseOptionAssign: () => { },
    ruleComponents: [],
    setRuleComponents:() => { },
    indexRule: 0, 
    setIndexRule: () => { },
});

export type CaseDesignContextValue = {
    caseDesignUpdate: any, 
    setCaseDesignUpdate: (caseDesignUpdate: any) => void,
    resetState: any;
    setResetState: (resetState: any) => void;
    Name: any;
    setName: (name: any) => void;
    Type: any;
    setType: (type: any) => void;
    typeCaseVisible: any;
    setTypeCaseVisible:(typeCaseVisible:any) => void;
    templates: any;
    setTemplates: (template: any) => void;
    eFormSubDocId: any,
    setEFormSubDocId: (eFormSubDocId: any) => void,
    department: any;
    setDepartment: (department: any) => void;
    descriptions: any;
    setDescriptions: (descriptions: any) => void,
    masterPage: any,
    setMasterPage: (page: any) => void,
    stages: any,
    setStages: (stage: any) => void,
    steps: any,
    setSteps: (step: any) => void,
    duration: any,
    setDuration: (duration: any) => void,
    timeInput: any,
    setTimeInput: (time: any) => void,
    stepsName: any,
    setStepsName: (name: any) => void,
    stagesName: any,
    setStagesName: (name: any) => void,
    timeHrs: any,
    setTimeHrs: (hour: any) => void,
    timeMin: any,
    setTimeMin: (minute: any) => void,
    timeDay: any
    setTimeDay:(day: any) => void,
    initialBoard: any,
    setBoard: (name: any) => void,
    ruleData:any, 
    setRuleData: (ruleData: any) => void,
    selectedRuleId: any, 
    setSelectedRuleId: (selectedRuleId: any) => void,
    ruleParameters: any, 
    setRuleParameters : (ruleParameters: any) => void,
    paramData:any, 
    setParamData:(paramData: any) => void,
    gotoData:any,
    setGotoData:(gotoData: any) => void,
    valueGotoIfData:any,
    setValueGotoIfData:(valueGotoIfData: any) => void,
    valueGotoElseData:any,
    setValueGotoElseData:(valueGotoElseData: any) => void,
    pageRule:any,
    setPageRule: (pageRule: any) => void,
    selectedCard: any, 
    setSelectedCard: (selectedCard: any) => void,
    selectedCardReference:any,
    setSelectedCardReference:  (selectedCardReference: any) => void,
    caseOptionAssign: any,
    setCaseOptionAssign: (caseOptionAssign: any) => void,
    ruleComponents: any,
    setRuleComponents:(ruleComponents: any) => void,
    indexRule: number, 
    setIndexRule:(indexRule: number) => void
}
export const CaseDesignProvider = (props: any) => {
    const [caseDesignUpdate, setCaseDesignUpdate]: any = useState();
    const [resetState, setResetState] = useState(settingPage.BASICINFO);
    const [Name, setName] = useState(null);
    const [Type, setType] = useState(null);
    const [typeCaseVisible, setTypeCaseVisible] = useState(null);
    const [templates, setTemplates] = useState(null);
    const [eFormSubDocId,setEFormSubDocId] = useState(null)
    const [department, setDepartment] = useState(null);
    const [descriptions, setDescriptions] = useState(null);
    const [masterPage, setMasterPage] = useState(null);
    const [stages, setStages] = useState(null);
    const [steps, setSteps] = useState(null);
    const [duration, setDuration] = useState("Hour");
    const [timeInput, setTimeInput] = useState(null);
    const [stepsName, setStepsName] = useState(null);
    const [stagesName, setStagesName] = useState(null);
    const [timeHrs, setTimeHrs] = useState(0);
    const [timeMin,setTimeMin] = useState(0);
    const [timeDay,setTimeDay] = useState(0);
    const [initialBoard, setBoard] = useState<any>(board)
    const [ruleData, setRuleData] = useState([]) //all rule
    const [selectedRuleId, setSelectedRuleId] = useState("") //selected rule แสดงหน้าจอ
    const [ruleParameters,setRuleParameters] = useState([]) //parameters ฟั่งขวา mappings
    const [paramData, setParamData] = useState([]) //all param
    const [gotoData, setGotoData] = useState<any>([]) //all goto
    const [valueGotoIfData, setValueGotoIfData] = useState<any>([]) //if goto
    const [valueGotoElseData, setValueGotoElseData] = useState<any>({}) //else goto
    const [pageRule, setPageRule] = useState(settingPageRule.FIRSTPAGE);
    const [selectedCard, setSelectedCard] = useState<any>({})
    const [selectedCardReference, setSelectedCardReference] = useState<any>({})
    const [caseOptionAssign, setCaseOptionAssign] = useState<any>();
    const [ruleComponents, setRuleComponents] = useState<RuleComponent[]>([{ id: 1, selectedRuleId: "", dataRule: {} }]);
    const [indexRule, setIndexRule] = useState<number>(0);


    const stateValue: CaseDesignContextValue = {
        caseDesignUpdate: caseDesignUpdate,
        setCaseDesignUpdate: setCaseDesignUpdate,
        resetState: resetState,
        setResetState: setResetState,
        Name: Name,
        setName: setName,
        caseOptionAssign,
        setCaseOptionAssign,
        Type: Type,
        setType: setType,
        typeCaseVisible:typeCaseVisible,
        setTypeCaseVisible:setTypeCaseVisible,
        templates: templates,
        setTemplates: setTemplates,
        department: department,
        eFormSubDocId: eFormSubDocId,
        setEFormSubDocId:setEFormSubDocId,
        setDepartment: setDepartment,
        descriptions: descriptions,
        setDescriptions: setDescriptions,
        masterPage: masterPage,
        setMasterPage: setMasterPage,
        stages: stages,
        setStages: setStages,
        steps: steps,
        setSteps: setSteps,
        duration: duration,
        setDuration: setDuration,
        timeInput: timeInput,
        setTimeInput: setTimeInput,
        stepsName: stepsName,
        setStepsName: setStepsName,
        stagesName: stagesName,
        setStagesName: setStagesName,
        timeHrs: timeHrs, 
        setTimeHrs: setTimeHrs,
        timeMin: timeMin,
        setTimeMin: setTimeMin,
        timeDay: timeDay,
        setTimeDay:setTimeDay,
        initialBoard: initialBoard, 
        setBoard: setBoard,
        ruleData:ruleData, 
        setRuleData: setRuleData,
        selectedRuleId: selectedRuleId, 
        setSelectedRuleId: setSelectedRuleId,
        ruleParameters: ruleParameters, 
        setRuleParameters : setRuleParameters,
        paramData:paramData, 
        setParamData:setParamData,
        gotoData:gotoData,
        setGotoData:setGotoData,
        valueGotoIfData:valueGotoIfData,
        setValueGotoIfData:setValueGotoIfData,
        valueGotoElseData:valueGotoElseData,
        setValueGotoElseData:setValueGotoElseData,
        pageRule:pageRule,
        setPageRule:setPageRule,
        selectedCard: selectedCard, 
        setSelectedCard: setSelectedCard,
        selectedCardReference:selectedCardReference,
        setSelectedCardReference: setSelectedCardReference,
        ruleComponents: ruleComponents, 
        setRuleComponents: setRuleComponents,
        indexRule: indexRule, 
        setIndexRule: setIndexRule
    };
    return (
        <CaseDesignContext.Provider value={stateValue}>
            {props.children}
        </CaseDesignContext.Provider>
    );
};